import { useNavigate, useParams } from 'react-router-dom';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { AccountTransactionsTable } from './AccountTransactionsTable';

const EMPTY_MESSAGES = {
    all: 'No transactions found',
    cash: 'No cash movements found',
    transfers: 'No transfers found',
};

export const AccountTransactionsTab = () => {
    const navigate = useNavigate();
    const { transactionType } = useParams<{ transactionType: string }>();
    const currentTab = transactionType === 'cash' || transactionType === 'transfers' ? transactionType : 'all';

    return (
        <Tabs value={currentTab} onValueChange={(value) => navigate(`../${value}`)}>
            <TabsList>
                <TabsTrigger value="all">All Transactions</TabsTrigger>
                <TabsTrigger value="cash">Cash Movements</TabsTrigger>
                <TabsTrigger value="transfers">Transfers</TabsTrigger>
            </TabsList>
            <TabsContent value={currentTab} className="mt-4">
                <AccountTransactionsTable
                    tableId={`accountTransactions${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)}`}
                    variant={currentTab}
                    emptyMessage={EMPTY_MESSAGES[currentTab]}
                />
            </TabsContent>
        </Tabs>
    );
};
